import { Injectable } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';
import { iiif$ } from '../../../../../../../utils/observable.extensions';
import { map, shareReplay } from 'rxjs/operators';
import { ProductType } from '../../../../../../../models/enum/dto/product-type.enum';
import { VariantType } from '../../../../../../../models/enum/dto/variant-type.enum';
import { exists } from '../../../../../../../functions/exists';
import { StiiizyCardData } from '../../../../../../../models/print-cards/stiiizy-card-data';

@Injectable()
export class StiiizyAddressCardStackContentViewModel extends PrintCardContentViewModel {
  public readonly cardData$: Observable<StiiizyCardData>;

  public readonly isStiiizyBrandedCard$ = this.cardData$.pipe(
    map(cardData => cardData?.isStiiizyBrandedCard()),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  public readonly stiiizyCardBackgroundColor$ = iiif$(this.isStiiizyBrandedCard$, of('black'), this.cardColor$).pipe(
    shareReplay({ bufferSize: 1, refCount: true })
  );

  public readonly sidebarAndContentGapInRem$ = this.isStiiizyBrandedCard$.pipe(
    map(isStiiizyBrandedCard => (isStiiizyBrandedCard ? 0.125 : 0))
  );

  public readonly isFlavorCardOrMultiStainCard$ = this.cardData$.pipe(
    map(cardData => cardData?.isFlavorCardOrMultiStrainCard())
  );

  public readonly hasFlavors$ = this.cardData$.pipe(map(cardData => cardData?.numberOfFlavorsOrStrains() > 1));

  public readonly showSidebar$ = combineLatest([this.isFlavorCardOrMultiStainCard$, this.hasFlavors$]).pipe(
    map(([isFlavorCard, hasFlavors]) => isFlavorCard && hasFlavors)
  );

  public readonly showCannabinoids$ = combineLatest([this.cardData$, this.propertiesBasedOnPools$]).pipe(
    map(([cardData, properties]) => {
      const productType = cardData?.rowProductType();
      const validProduct =
        productType === ProductType.Beverage ||
        productType === ProductType.Edible ||
        productType === ProductType.Oil ||
        productType === ProductType.Wellness ||
        cardData?.rowVariantType() === VariantType.Capsule;
      return validProduct && exists(properties?.length);
    })
  );
}
